<!-- Spacer -->
<div
    class="platform-horizontal-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
